import React from 'react'
import FileItem from './fileItem'
import './fileList.css'

class FileList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {

        }
    }

    handleItemClick = (fileName,dirId,fileType) => {
        this.props.handleItemClick(fileName,dirId,fileType);
    };

    handleDeleteFile = (fileId) => {
        this.props.handleDelete(fileId);
    };

    handleRenameFile = (fileId) => {
        this.props.handleRenameFile(fileId);
    };

    render() {
        let currentDir = this.props.currentDir;
        return (
                <div className='div_list_style'>
                    <ul style={{height:97 + '%',padding:0 + 'px',maxHeight:97 + '%',overflowY:'auto'}}> {
                        currentDir.map((item, index) => {
                                return <FileItem key={index} type={item.is_directory}
                                                 fileName={item.file_name}
                                                 dirId={item.file_id}
                                                 modifyTime={item.modify}
                                                 style={{display:'block'}}
                                                 handleItemClick={this.handleItemClick}
                                                 handleDelete={this.handleDeleteFile}
                                                 handleRename={this.handleRenameFile}/>
                            }
                        )
                    }
                    </ul>
                </div>
        );
    }
}
export default FileList
